export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 2.0,
        "transcript": "That'll be useful.",
        "translation": "That'll be useful."
    },
    "2": {
        "startTime": 6.0,
        "endTime": 8.0,
        "transcript": "Right, we're ready.",
        "translation": "Right, we're ready."
    },
    "3": {
        "startTime": 10.6,
        "endTime": 16.0,
        "transcript": "Okay, for the record, speaking to James Guy, Kuiggluk.",
        "translation": "Okay, for the record, speaking to James Guy, Kwethluk."
    },
    "4": {
        "startTime": 24.0,
        "endTime": 30.0,
        "transcript": "Imkut-qaa, imkut-qaa qasgimi uitalallret angullrunritaten?",
        "translation": "Were you born in time to see those who lived in the community house?"
    },
    "5": {
        "startTime": 30.5,
        "endTime": 32.0,
        "transcript": "Anguqallruanka.",
        "translation": "I was born in time to see them."
    },
    "6": {
        "startTime": 34.0,
        "endTime": 38.0,
        "transcript": "Qanengssaaraliyatullrulua-llu maqinerra'arqata.",
        "translation": "And I always went to listen to them speaking right after they took fire baths."
    },
    "7": {
        "startTime": 39.0,
        "endTime": 47.5,
        "transcript": "Qanengssaaraitnek angukara'urluut, wangni tua-i angukara'urluut tan'gaurlucuarama, niicugniuryarturluki.",
        "translation": "I would go listen to the words of the old men the men I thought of as old because I was a small boy."
    },
    "8": {
        "startTime": 49.5,
        "endTime": 57.0,
        "transcript": "Tua-i anglanakluku qanengssaarallrat. Picirraatun tua-i qanengssaarnaurtut.",
        "translation": "I thought it was fun when they spoke. They would speak as they were."
    },
    "9": {
        "startTime": 58.0,
        "endTime": 64.5,
        "transcript": "Imkut tua-i nallunrilnge'rmegteggu-llu qanengssaa ilameng niicugniurnauraat.",
        "translation": "And even when they knew what he was talking about his peers would listen to him."
    },
    "10": {
        "startTime": 67.5,
        "endTime": 71.5,
        "transcript": "Tua-i-llu ala'arcan qanrulluki iqlutun piqerniluku.",
        "translation": "And then when he made a small mistake, they would tell him that he had made a mistake."
    },
    "11": {
        "startTime": 72.5,
        "endTime": 73.5,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "12": {
        "startTime": 74.0,
        "endTime": 76.0,
        "transcript": "Canek qalartelallruat?",
        "translation": "Whatpl did they used to talk about?"
    },
    "13": {
        "startTime": 76.5,
        "endTime": 81.5,
        "transcript": "Piciatun imkunek angalkullruarnek, angalkurrarnek.",
        "translation": "Various things, those who were shamans, shamans with some power."
    },
    "14": {
        "startTime": 84.0,
        "endTime": 91.0,
        "transcript": "Tamakunek qanengssaararaqluteng aqvautaalallritnek tuaten.",
        "translation": "They would talk about those, even how they held running races."
    },
    "15": {
        "startTime": 93.0,
        "endTime": 100.5,
        "transcript": "Curulallritnek-ll' anguyiit anguyangqetulliniameng nutem pitgaqulluteng.",
        "translation": "And how warriors attacked, because there had always been warriors that shot each other with arrows."
    },
    "16": {
        "startTime": 100.6,
        "endTime": 103.0,
        "transcript": "Tamakunek qanengsaarnaurtut.",
        "translation": "They would talk about those."
    },
    "17": {
        "startTime": 103.5,
        "endTime": 105.0,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "18": {
        "startTime": 106.0,
        "endTime": 106.9,
        "transcript": "Atam…",
        "translation": "You see…"
    },
    "19": {
        "startTime": 107.0,
        "endTime": 112.0,
        "transcript": "Tamakut-qaa elitnaurvigtun ayuqelallruut qasgit?",
        "translation": "Were those community houses like schools?"
    },
    "20": {
        "startTime": 113.0,
        "endTime": 115.5,
        "transcript": "Elitnaurvigtun ayuqeksaitut.",
        "translation": "They weren't like schools."
    },
    "21": {
        "startTime": 117.0,
        "endTime": 126.0,
        "transcript": "Cali waten unani pinerrluga'artellria apqemteńek yuut pissuutaitnek teglek'alleq",
        "translation": "Also, when someone misbehaved like this down there what we call those who've stolen people's tools"
    },
    "22": {
        "startTime": 127.0,
        "endTime": 138.5,
        "transcript": "Maqinermek taq'aqameng ukut tegganret aqvavkarnauraat tauna tuaten picurlakarniluku nunameggni wani.",
        "translation": "When these elders were done taking fire baths, they would get him telling him that there had been trouble in their village."
    },
    "23": {
        "startTime": 139.5,
        "endTime": 142.9,
        "transcript": "Council-aaqeryugluku, tua-i kitugarcugluku.",
        "translation": "They wanted to try him, to assuage [the situation]."
    },
    "24": {
        "startTime": 144.0,
        "endTime": 150.5,
        "transcript": "Tua-i-ll' aqvaluku tua-i tauna nutaan quyurmeng inerqurrluku tuaten pinqigtesqevkenaku",
        "translation": "And then they brought him, then admonished him together not to do that again."
    },
    "25": {
        "startTime": 151.0,
        "endTime": 154.7,
        "transcript": "Tamana teglegyaraq assinritniluku.",
        "translation": "Saying that stealing is bad."
    },
    "26": {
        "startTime": 156.0,
        "endTime": 159.9,
        "transcript": "Tua-i tuaten takurqautelaraatnga.",
        "translation": "That's what they revealed to me."
    },
    "27": {
        "startTime": 162.0,
        "endTime": 171.0,
        "transcript": "Cali wiinga uksuq aipaqa-llu waten-wa tua-i piniarqaanemnek calirpagciigalama",
        "translation": "Also, my wife and I last winter, because I can't work very hard ever since I became weak"
    },
    "28": {
        "startTime": 172.0,
        "endTime": 177.5,
        "transcript": "Sulunaucetellruukuk ukuk yuugka qanruqu'urlukek kiak.",
        "translation": "We2 would get salted fish last summer telling my children2."
    },
    "29": {
        "startTime": 179.5,
        "endTime": 186.0,
        "transcript": "Tua-i-ll' uksuq aqvayaaqerpuk pingayuungata sulunat.",
        "translation": "And then last winter, we2 went to get it because there were three [containers of] salted fish."
    },
    "30": {
        "startTime": 187.0,
        "endTime": 195.5,
        "transcript": "Malruk tayima, una-llu puckam avga cali, avga tayima tegulliniluku, tua-i carraq tau͡gaam.",
        "translation": "Two of them, and half of this barrel, someone had taken half, and only a little [was left]."
    },
    "31": {
        "startTime": 197.0,
        "endTime": 201.0,
        "transcript": "Tua-i ilulliqsaaqua uterrngailata. Qanqaqsaitua.",
        "translation": "I was sad because they wouldn't be returned. I didn't say anything."
    },
    "32": {
        "startTime": 202.0,
        "endTime": 207.5,
        "transcript": "Taumek watua waniw' qaneryukapigtua yugnun niiciiqngatgu.",
        "translation": "That's why I really want to say something now because people will hear it."
    },
    "33": {
        "startTime": 209.0,
        "endTime": 212.5,
        "transcript": "Waniw' waten ayuquq,",
        "translation": "This is what it's like,"
    },
    "34": {
        "startTime": 215.7,
        "endTime": 225.5,
        "transcript": "Nutem-llu imkuni alerquutni imkuni Ten Commandments, taukuni ekumaluni: “Thou shall not steal,” “Teglegyaqunak.”",
        "translation": "It's also in those ancient commandments, [the] Ten Commandments, it's in there: “Thou shall not steal,” “Teglegyaqunak.”"
    },
    "35": {
        "startTime": 227.0,
        "endTime": 237.0,
        "transcript": "Yaa, taumek waniw' nuna tamalkuita yuit inerquranka",
        "translation": "Yes, that's why I'm admonishing all of the people of the land now"
    },
    "36": {
        "startTime": 239.5,
        "endTime": 251.5,
        "transcript": "Inerquryaaqanka-wa tua-i yuum pianek tangengraata wall'u neqlillernun tekitengraata pisqevkenaki, tegutesqevkenaki.",
        "translation": "I'm admonishing them that even if they see a person's things or even if they come upon fish camps not to take anything."
    },
    "37": {
        "startTime": 252.0,
        "endTime": 255.5,
        "transcript": "Tau͡gaam waten tegucukata pisqelluki:",
        "translation": "But if they want to take anything, do this:"
    },
    "38": {
        "startTime": 256.5,
        "endTime": 265.5,
        "transcript": "Kalikarrarmek igaqerluku tuaten pitalriamek tegutniluku yuk tauna tuaken, at'ni-llu elliluku.",
        "translation": "Write on a piece of paper that a person is taking that much and write his name."
    },
    "39": {
        "startTime": 266.0,
        "endTime": 269.5,
        "transcript": "Tuaten pikan taum yua quyaciquq.",
        "translation": "If [s]he does that, the owner will be grateful."
    },
    "40": {
        "startTime": 270.0,
        "endTime": 278.0,
        "transcript": "Waten-llu qanerluni: “Enulliarturlulliniami-w' tua-i tuaten nallunaunani pilria. Quyanarquq tuaten piluni.”",
        "translation": "[S]he will also say this: “[S]he probably let me know because [s]he's lacking. I'm thankful that [s]he did that.”"
    },
    "41": {
        "startTime": 279.0,
        "endTime": 283.0,
        "transcript": "Nalluvkarpek'naku yua kalikarrarkun catailengraan.",
        "translation": "Let the owner know with a piece of paper even if [s]he's gone."
    },
    "42": {
        "startTime": 283.5,
        "endTime": 287.0,
        "transcript": "Wiinga-llu tarranqellemni imum… Pinky nallunritan.",
        "translation": "And when I was young and healthy, that person… You know Pinky."
    },
    "43": {
        "startTime": 288.5,
        "endTime": 295.0,
        "transcript": "Ingrini pagaani enullitaqama, enullitelgulaama-ll' iliini",
        "translation": "When I was lacking up in the mountains, because I lacked sometimes"
    },
    "44": {
        "startTime": 297.0,
        "endTime": 302.0,
        "transcript": "Tekitaqamku camp-aa camek aturyung'e'rma piksaitelallruunga.",
        "translation": "When I came upon his camp, even if I wanted to use something, I never did."
    },
    "45": {
        "startTime": 302.5,
        "endTime": 312.0,
        "transcript": "Tua-i-ll' tangrramku qanrulluku enullit'ngerma camp-anun tekiteng'e'rma qaillukuaqanritnilua.",
        "translation": "And then when I saw him, I would tell him that even when I lacked even though I came upon his camp that I didn't touch anything."
    },
    "46": {
        "startTime": 312.5,
        "endTime": 314.0,
        "transcript": "Waten alerqularaanga:",
        "translation": "He would instruct me like this:"
    },
    "47": {
        "startTime": 314.5,
        "endTime": 322.5,
        "transcript": "Uumiku-gguq kitak' arcaqalriamek enulliskuma puckami-gguq taquari ekumalartut.",
        "translation": "The next time I am lacking something important his provisions are put inside the barrel."
    },
    "48": {
        "startTime": 323.0,
        "endTime": 328.0,
        "transcript": "Tauna-gguq ikirrluku yuarlua aturyukemnek teguskilii",
        "translation": "He said that I should open it, look for what I need, and take it"
    },
    "49": {
        "startTime": 328.2,
        "endTime": 333.5,
        "transcript": "Atqa-llu-gguq igaulluku, tuaten-llu-gguq pitalriamek tuaken puckamek aturnilua.",
        "translation": "And he said to write my name, and how much I've taken from that barrel."
    },
    "50": {
        "startTime": 334.0,
        "endTime": 336.5,
        "transcript": "Tau͡gaam wii tuaten piksaitua.",
        "translation": "But I never did that."
    },
    "51": {
        "startTime": 337.0,
        "endTime": 340.0,
        "transcript": "Arcaqalriamek-wa tua-i enullitqapigteksailngua",
        "translation": "I haven't completely lacked anything important"
    },
    "52": {
        "startTime": 340.5,
        "endTime": 345.0,
        "transcript": "Tarratelgullruama ayagyuarlua avani yuilqumi.",
        "translation": "Because I always traveled in the wilderness over there when I was young."
    },
    "53": {
        "startTime": 347.0,
        "endTime": 348.0,
        "transcript": "Cali…",
        "translation": "Also..."
    },
    "54": {
        "startTime": 353.0,
        "endTime": 359.5,
        "transcript": "Makut-mi, angullruaten-qaa, angullruan-qaa imna Aavaaq?",
        "translation": "What about these, were you born in time to see Aavaaq?"
    },
    "55": {
        "startTime": 360.0,
        "endTime": 361.5,
        "transcript": "Yaa, angullruaqa.",
        "translation": "Yes, I was born in time to see him."
    },
    "56": {
        "startTime": 362.0,
        "endTime": 368.5,
        "transcript": "Niitelartua-am, alartelallilrianga-wa niillua, angalkullraullruniluku.",
        "translation": "I've heard, I've probably heard wrong, that he was a shaman."
    },
    "57": {
        "startTime": 369.0,
        "endTime": 371.0,
        "transcript": "Angalkuunrit'urluryaaquq.",
        "translation": "The poor guy wasn't a shaman."
    },
    "58": {
        "startTime": 371.1,
        "endTime": 372.0,
        "transcript": "Akleng, ii-i.",
        "translation": "Poor guy, I see."
    },
    "59": {
        "startTime": 372.1,
        "endTime": 373.9,
        "transcript": "Angalkuunrit'urluryaaquq.",
        "translation": "The poor guy wasn't a shaman."
    },
    "60": {
        "startTime": 374.5,
        "endTime": 379.0,
        "transcript": "Tau͡gaam imuullruuq, yuungcarauluni, yaa.",
        "translation": "But he was, you know, treated by a shaman [in utero], yes."
    },
    "61": {
        "startTime": 379.1,
        "endTime": 381.0,
        "transcript": "Yuungcarauvalallruat-gguq yuut.",
        "translation": "People said that he was treated by a shaman [in utero]."
    },
    "62": {
        "startTime": 381.1,
        "endTime": 384.0,
        "transcript": "Yuungcaravallagniluku tau͡gaam qanengssak'laraat.",
        "translation": "They only say that he was treated by a shaman."
    },
    "63": {
        "startTime": 384.1,
        "endTime": 385.0,
        "transcript": "Qaillun?",
        "translation": "How?"
    },
    "64": {
        "startTime": 385.1,
        "endTime": 386.9,
        "transcript": "Yuungcaravallagluku.",
        "translation": "That he was treated by a shaman."
    },
    "65": {
        "startTime": 388.0,
        "endTime": 392.5,
        "transcript": "Yuungnaqevkarpallagluku-wa Taqukamek napacirluku. (Yuungcatullrullikait-wa ak'a acirluki.)",
        "translation": "He was named Taqukaq to keep him clinging to life. (Shamans used to treat them in utero by giving them names.)"
    },
    "66": {
        "startTime": 393.0,
        "endTime": 394.9,
        "transcript": "Ellminek-qaa pillrunrituq?",
        "translation": "He didn't [treat] himself?"
    },
    "67": {
        "startTime": 395.0,
        "endTime": 397.9,
        "transcript": "Yaa, angalkut-wa tua-i tuaten piluku.",
        "translation": "Yes, shamans did that to him."
    },
    "68": {
        "startTime": 399.0,
        "endTime": 407.9,
        "transcript": "Taumek-gguq aurrlermini imkunek makunek naugaarnek canegnek waten elliurturluni ner'aqan",
        "translation": "They say that that's why when he was crawling when he did this, eating plants, grass"
    },
    "69": {
        "startTime": 408.0,
        "endTime": 411.5,
        "transcript": "Man'a tua-i green-aarurtelalria canegtullra.",
        "translation": "This part where he ate grass would turn green."
    },
    "70": {
        "startTime": 412.0,
        "endTime": 414.7,
        "transcript": "Aaniin-llu-gguq inerquyuunaku.",
        "translation": "And they say that his mother never admonished him [against that]."
    },
    "71": {
        "startTime": 416.5,
        "endTime": 421.5,
        "transcript": "Angalkuunrit'urlullruyaaquq tau͡gaam tuaten tua-i yuungcarauluni.",
        "translation": "The poor guy wasn't a shaman, but he was treated by one like that."
    },
    "72": {
        "startTime": 424.0,
        "endTime": 426.0,
        "transcript": "Makut angullruaten…",
        "translation": "Were you born in time to see these…"
    },
    "73": {
        "startTime": 428.0,
        "endTime": 429.9,
        "transcript": "Yugcetun ima reindeer-at caulalriit?",
        "translation": "What are reindeer in Yup'ik again?"
    },
    "74": {
        "startTime": 430.6,
        "endTime": 431.5,
        "transcript": "Tuntut. (Yaa.)",
        "translation": "Tuntut. (Yes.)"
    },
    "75": {
        "startTime": 432.0,
        "endTime": 433.0,
        "transcript": "Tamakut-qaa…",
        "translation": "Were those…"
    },
    "76": {
        "startTime": 435.5,
        "endTime": 438.9,
        "transcript": "Angullruanka. (Qalamcikqeqaqerki kitak'.)",
        "translation": "I was born in time to see them. (Please talk about them.)"
    },
    "77": {
        "startTime": 439.0,
        "endTime": 446.0,
        "transcript": "Yaa, tuntunek maagiyartulrianun-llu maligucunqeggama atamnun",
        "translation": "Yes, because I liked to go with my father to mark reindeer"
    },
    "78": {
        "startTime": 448.0,
        "endTime": 452.5,
        "transcript": "Tunciuryarturaqata Akiacuarmun maligut'lallruunga.",
        "translation": "I used to go with them to herd reindeer in Akiachak."
    },
    "79": {
        "startTime": 455.0,
        "endTime": 462.5,
        "transcript": "Tua-i unuakumi taglartut Akiacuarmek maagiyarturqameng.",
        "translation": "In the morning, they would go up from Akiachuk to mark reindeer."
    },
    "80": {
        "startTime": 467.0,
        "endTime": 474.0,
        "transcript": "Can'gurpatagyugmek yaaken itercivigmun-gguq iterrluki pilarait.",
        "translation": "They said that they would corral them from a massive meadow over there."
    },
    "81": {
        "startTime": 475.5,
        "endTime": 479.9,
        "transcript": "Tuaken-llu tua-i uss'arulluki wavet paivcivigmun-gguq.",
        "translation": "And from there, they said that they would take them to the waiting area so that they could look around."
    },
    "82": {
        "startTime": 481.5,
        "endTime": 483.5,
        "transcript": "Aterluteng-am tua-i casgut.",
        "translation": "The fences had names."
    },
    "83": {
        "startTime": 485.5,
        "endTime": 491.5,
        "transcript": "Tuaken-llu tua-i paivcivigmek nutegkun iterrluki.",
        "translation": "And from the waiting area there, they would bring them in through the corraling path."
    },
    "84": {
        "startTime": 493.0,
        "endTime": 496.5,
        "transcript": "Taksiyaagpek'nani nutek. Iqkunani.",
        "translation": "The corraling path wasn't long. It was narrow."
    },
    "85": {
        "startTime": 497.0,
        "endTime": 501.0,
        "transcript": "Tuntut tua-i atauciq tamaagguirturaraqluni.",
        "translation": "The reindeer would go through there one at a time."
    },
    "86": {
        "startTime": 501.7,
        "endTime": 504.9,
        "transcript": "Cukangnaqellriit-wa [qaill'-qaa] aarnaqluteng.",
        "translation": "Those who were fast were dangerous."
    },
    "87": {
        "startTime": 506.0,
        "endTime": 509.7,
        "transcript": "Nang'e'rtaqluteng tuaten ilateng tutmarluki piaqluteng.",
        "translation": "They would even suddenly stand and tread over the others."
    },
    "88": {
        "startTime": 512.0,
        "endTime": 514.5,
        "transcript": "Ataucim-llu naaqurluki.",
        "translation": "And one person would count them."
    },
    "89": {
        "startTime": 517.0,
        "endTime": 523.0,
        "transcript": "Tua-i alarcuunani waten kalik'vagnek tegumiarluni qayagpagaurluni.",
        "translation": "[S]he never made a mistake, holding large papers, calling out."
    },
    "90": {
        "startTime": 525.0,
        "endTime": 532.0,
        "transcript": "Ingkut-llu tua-i cetamauluteng cali callugtet tuaken nutegmek anelriit.",
        "translation": "And over there, there were four wrestlers coming out of that corraling path."
    },
    "91": {
        "startTime": 533.5,
        "endTime": 539.5,
        "transcript": "[Amna] pakmaanaaraqan ingkut tua-i callugtet ingcuqernaurtut waten akiqliqa'arrluku.",
        "translation": "When it was overflowing over there, the wrestlers would wait to catch them across from each other like this."
    },
    "92": {
        "startTime": 540.0,
        "endTime": 545.5,
        "transcript": "Tua-i-llu tuntum qamiqurra pugngan egmian teguqerluku, callugluku, maagluku.",
        "translation": "And then when its head appeared, they would take it right away, wrestle it, and mark it."
    },
    "93": {
        "startTime": 546.0,
        "endTime": 549.0,
        "transcript": "Maagumalriit tau͡gken tua-i anevkarturluki.",
        "translation": "However, they would let out those that were marked."
    },
    "94": {
        "startTime": 550.5,
        "endTime": 552.0,
        "transcript": "Maagumanilnguut tau͡gaam maagaqluki.",
        "translation": "They would only mark the ones that weren't marked."
    },
    "95": {
        "startTime": 552.5,
        "endTime": 554.0,
        "transcript": "Qaillun maagluki?",
        "translation": "What do you mean maagluki?"
    },
    "96": {
        "startTime": 554.1,
        "endTime": 557.0,
        "transcript": "Mark-arluki-wa ciutaitgun. Yaa.",
        "translation": "Mark them on their ears. Yes."
    },
    "97": {
        "startTime": 558.0,
        "endTime": 559.0,
        "transcript": "Nuussikun?",
        "translation": "With a knife?"
    },
    "98": {
        "startTime": 559.1,
        "endTime": 560.5,
        "transcript": "Yaa, nuussikun.",
        "translation": "Yes, with a knife."
    },
    "99": {
        "startTime": 560.6,
        "endTime": 565.5,
        "transcript": "Atam qayagpagaurtet-llu tuntut elisngaluki.",
        "translation": "You see, the callers knew the reindeer."
    },
    "100": {
        "startTime": 566.5,
        "endTime": 567.9,
        "transcript": "Taumun, taumun yug[mun]…",
        "translation": "[Belonging] to that person…"
    },
    "101": {
        "startTime": 568.0,
        "endTime": 569.9,
        "transcript": "Avaurilkilartua.",
        "translation": "I never forget something."
    },
    "102": {
        "startTime": 570.0,
        "endTime": 573.5,
        "transcript": "Qaterpaurpallermek-llam au͡g'umek irrilrianga.",
        "translation": "I was amazed at that extremely white one."
    },
    "103": {
        "startTime": 574.5,
        "endTime": 577.5,
        "transcript": "Qaillun piluni man'a qaterta tuntu?",
        "translation": "How did this reindeer get white?"
    },
    "104": {
        "startTime": 577.6,
        "endTime": 582.5,
        "transcript": "Piqerluni-am tamaaggun ayagtuq nutegkun apqiitgun nutegkun.",
        "translation": "One day, it went through that corraling path through what they call the nutek."
    },
    "105": {
        "startTime": 585.0,
        "endTime": 587.0,
        "transcript": "Am'um-am tekican qayagpagaa.",
        "translation": "When it arrived, someone over there called it."
    },
    "106": {
        "startTime": 587.5,
        "endTime": 590.5,
        "transcript": "Nalluyagutenrilkeka-am waniwa qayagpallra:",
        "translation": "I've never forgotten this, what he said:"
    },
    "107": {
        "startTime": 591.0,
        "endTime": 593.0,
        "transcript": "“Qayaksuk's there.”",
        "translation": "“Qayaksuk's there.”"
    },
    "108": {
        "startTime": 594.0,
        "endTime": 598.0,
        "transcript": "Qayaksuum pikliniluku tauna tuntu.",
        "translation": "That reindeer apparently belonged to Qayaksuk."
    },
    "109": {
        "startTime": 598.2,
        "endTime": 601.9,
        "transcript": "Tua-i ciutaitgun nalluyuunaki qayagaurtet.",
        "translation": "The callers knew them by their ears."
    },
    "110": {
        "startTime": 603.5,
        "endTime": 607.0,
        "transcript": "Tuaken-llu callugvigmek ancamegteggu yaavet",
        "translation": "And when they took them out of that wrestling area over there"
    },
    "111": {
        "startTime": 609.0,
        "endTime": 611.5,
        "transcript": "Casgumun cali anlluku.",
        "translation": "They brought it out again to the fence."
    },
    "112": {
        "startTime": 611.6,
        "endTime": 614.0,
        "transcript": "Cali-am egmian ayagturtessuunaki.",
        "translation": "They wouldn't let them go about right away either."
    },
    "113": {
        "startTime": 614.5,
        "endTime": 618.5,
        "transcript": "Muiqertaqan-am tauna nangneqliq casgu",
        "translation": "When that last [area with a] fence was full"
    },
    "114": {
        "startTime": 619.5,
        "endTime": 622.5,
        "transcript": "Ikirulluki tuntut imkut anevkarnaurait.",
        "translation": "They would open them and let those reindeer out."
    },
    "115": {
        "startTime": 622.6,
        "endTime": 625.0,
        "transcript": "Nang'ngata-llu patuluku.",
        "translation": "And they closed it when they were all through."
    },
    "116": {
        "startTime": 625.5,
        "endTime": 629.5,
        "transcript": "Tua-i free-rluki, amkut tau͡gaam taigarkat.",
        "translation": "They freed them, except for those that were still to come."
    },
    "117": {
        "startTime": 630.5,
        "endTime": 634.0,
        "transcript": "Tua-i anglanaqluteng anglaniurallret.",
        "translation": "It was fun watching them have fun."
    },
    "118": {
        "startTime": 639.0,
        "endTime": 644.9,
        "transcript": "Calistet calisterluteng cali camani camp-ami pinaurtut.",
        "translation": "The workers [on the field] also had workers down in the camp."
    },
    "119": {
        "startTime": 645.0,
        "endTime": 646.5,
        "transcript": "Kenirterluteng.",
        "translation": "They had cooks."
    },
    "120": {
        "startTime": 648.0,
        "endTime": 651.0,
        "transcript": "Kenirteteng-llu-w' akililallikait tuntumek.",
        "translation": "They probably paid their cooks with reindeer."
    },
    "121": {
        "startTime": 653.5,
        "endTime": 659.0,
        "transcript": "Atrarqama murilkeńaurtua imna waten tank-am avga egatiit.",
        "translation": "When I went down, I would see that they used half of a tank as a cooking pot."
    },
    "122": {
        "startTime": 659.5,
        "endTime": 662.0,
        "transcript": "Tuntuvik tamalkuan ek'lalliat.",
        "translation": "They probably put the entire reindeer herd in."
    },
    "123": {
        "startTime": 663.0,
        "endTime": 667.0,
        "transcript": "Tua-lli-wa tua-i yugugaat imkut arnartuumarmeng-llu piliyatuameng",
        "translation": "And so, because that multitude would go along with women"
    },
    "124": {
        "startTime": 667.5,
        "endTime": 671.5,
        "transcript": "Utumaumalriit, irniayagiunrilnguut-wa",
        "translation": "The [women] with less responsibility who were not taking care of children"
    },
    "125": {
        "startTime": 674.5,
        "endTime": 682.0,
        "transcript": "Egalvall'er imna tank-am avga nanglaqiit yuut apiatarqameng.",
        "translation": "The people would finish that huge pot, half of a tank, when they had lunch."
    },
    "126": {
        "startTime": 683.0,
        "endTime": 688.0,
        "transcript": "Tua-i Kass'acetun break time, lunch break time-araqluteng.",
        "translation": "In English, they would have break time, lunch break time."
    },
    "127": {
        "startTime": 688.5,
        "endTime": 690.5,
        "transcript": "Ayuquciq-wa Kass'artailnguq.",
        "translation": "There were no Caucasians."
    },
    "128": {
        "startTime": 691.0,
        "endTime": 694.0,
        "transcript": "Twelve kela'agluku nernariniluku.",
        "translation": "They would say it's time to eat at 12 o'clock."
    },
    "129": {
        "startTime": 697.0,
        "endTime": 699.0,
        "transcript": "Kiimeng-qaa taukut…",
        "translation": "Were they the only ones…"
    },
    "130": {
        "startTime": 699.1,
        "endTime": 701.0,
        "transcript": "Akiacuarmi pitullruut.",
        "translation": "They used to in Akiachak."
    },
    "131": {
        "startTime": 702.0,
        "endTime": 707.0,
        "transcript": "Maalirnermun tau͡gaam piaqameng pikani Akulikutaq Corral, tuani pilallruut.",
        "translation": "But when they did it towards here up on Akulikutaq Corral, that's where they went."
    },
    "132": {
        "startTime": 707.5,
        "endTime": 713.0,
        "transcript": "Tau͡gaam wiinga yaaqsikluku mikcuaraungama maligucuitellruunga.",
        "translation": "But because I thought it was far since I was small, I didn't go with them."
    },
    "133": {
        "startTime": 716.0,
        "endTime": 719.0,
        "transcript": "Elitnauraulaama-llu-wa tamatum nalliini.",
        "translation": "It was also because I was a student at that time."
    },
    "134": {
        "startTime": 719.5,
        "endTime": 724.0,
        "transcript": "Akiacuarmun tau͡gaam piaqata canimelan maligutaqlua.",
        "translation": "But when they went to Akiachak, I would go along since it was close."
    },
    "135": {
        "startTime": 727.0,
        "endTime": 735.0,
        "transcript": "Tamatum-qaa nalliini tuntuviulallerpeceńi makut imkut keglunret pilallruut?",
        "translation": "Back when youpl herded reindeer, were there wolves?"
    },
    "136": {
        "startTime": 735.5,
        "endTime": 738.0,
        "transcript": "Yaa, pilallruut.",
        "translation": "Yes, there were."
    },
    "137": {
        "startTime": 742.0,
        "endTime": 744.0,
        "transcript": "Keglunertairucuitellruuq.",
        "translation": "There always used to be wolves."
    },
    "138": {
        "startTime": 744.5,
        "endTime": 749.0,
        "transcript": "Keglunertaicuitellruuq qanengssakaqani old man-ama.",
        "translation": "There were always wolves in my old man's stories."
    },
    "139": {
        "startTime": 750.0,
        "endTime": 755.0,
        "transcript": "Tua-i waten-llu pinaurtuq:",
        "translation": "He would say this:"
    },
    "140": {
        "startTime": 758.0,
        "endTime": 766.0,
        "transcript": "“Tuntut-gguq-am ayakaulluki tuqurqilaakalliniuq, tamakut keglunret.”",
        "translation": "“It drove the reindeer and killed one, those wolves.”"
    },
    "141": {
        "startTime": 768.0,
        "endTime": 778.0,
        "transcript": "Tau͡gaam tuntutairut'ngartellrani wavet-wa nugtartellratni government-aamun",
        "translation": "But when the reindeer declined, when they were taken under the governement"
    },
    "142": {
        "startTime": 779.0,
        "endTime": 782.0,
        "transcript": "Tamakut tuntut governemnt-aarurtellratni",
        "translation": "When those reindeer were taken under the government"
    },
    "143": {
        "startTime": 782.5,
        "endTime": 786.0,
        "transcript": "Murilkenrillrui, murilkenrillrui.",
        "translation": "He stopped herding, he stopped herding."
    },
    "144": {
        "startTime": 788.0,
        "endTime": 795.0,
        "transcript": "Caaqameng-llu-gguq tua-i tuntut ayalartut, qemikun-llu tevluteng, iquani-ll' cataunateng.",
        "translation": "They also said that reindeer would sometimes go, go over a hill, and they disappeared from the end."
    },
    "145": {
        "startTime": 795.5,
        "endTime": 800.0,
        "transcript": "Tamaa-i ircen'e'rnun-wa piyuk'laqait.",
        "translation": "They think that the legendary little people took them."
    },
    "146": {
        "startTime": 803.0,
        "endTime": 805.0,
        "transcript": "Kiituani-gguq tuntut…",
        "translation": "Eventually, they said that the reindeer…"
    },
    "147": {
        "startTime": 806.0,
        "endTime": 813.0,
        "transcript": "Tuntuurtellruyaaquq all over, pau͡gna maraq, ingrit, agna-llu.",
        "translation": "It had become covered in reindeer all over, up in the marsh, mountains, and across there."
    },
    "148": {
        "startTime": 813.8,
        "endTime": 818.0,
        "transcript": "Tau͡gaam tuaten piluteng keglunerrlainaat nangenritait.",
        "translation": "But that happened; wolves aren't the only ones that depleted them."
    },
    "149": {
        "startTime": 818.5,
        "endTime": 825.0,
        "transcript": "Tamakut tau͡gaam tuaten paqritaqluteng-gguq patagmek nang'ut.",
        "translation": "But that said that they were quickly depleted when they vanished like that."
    },
    "150": {
        "startTime": 829.0,
        "endTime": 831.0,
        "transcript": "Niiteqallruunga-am waten:",
        "translation": "This is what I heard:"
    },
    "151": {
        "startTime": 831.5,
        "endTime": 836.9,
        "transcript": "Anguyagtet-gguq-qaa taukut tuntuviit, tuntut taitellruit maavet.",
        "translation": "They said that the government brought those reindeer herding places here."
    },
    "152": {
        "startTime": 837.0,
        "endTime": 842.0,
        "transcript": "Tua-llu-gguq elicaryaaqluki amaken",
        "translation": "And then they said that they had teachers from outside"
    },
    "153": {
        "startTime": 845.0,
        "endTime": 852.0,
        "transcript": "Au͡g'umek Lapp-amek tailluteng maavet elicarluki yuut tuntuviuryaramek.",
        "translation": "They brought a Saami person here to teach people how to herd reindeer."
    },
    "154": {
        "startTime": 852.1,
        "endTime": 865.0,
        "transcript": "Tua-llu-gguq ayiita tamakut yuut aulukluki tuntuviit aulukcurlaki nangellruvkalarniit.",
        "translation": "And then they said that when they left, Yupiit took care of reindeer herds and they were depleted because they didn't take care of them well."
    },
    "155": {
        "startTime": 865.5,
        "endTime": 866.9,
        "transcript": "Tamana-qaa piciuluni?",
        "translation": "Is that true?"
    },
    "156": {
        "startTime": 867.0,
        "endTime": 868.9,
        "transcript": "Nuu, piciunrituq tamana.",
        "translation": "No, that's not true."
    },
    "157": {
        "startTime": 869.5,
        "endTime": 871.5,
        "transcript": "Aulukcurlaumallrunritut.",
        "translation": "They weren't taken care of badly."
    },
    "158": {
        "startTime": 872.0,
        "endTime": 876.5,
        "transcript": "Taum tua-i old man-ama qanrutkelallrui tua-i tuaten.",
        "translation": "That old man of mine used to talk about them like that."
    },
    "159": {
        "startTime": 876.6,
        "endTime": 881.0,
        "transcript": "Keglunerrlainarnun nangenritniluki, tau͡gaam cataitaqluteng.",
        "translation": "He said that wolves weren't the only ones that depleted them, but they vanished."
    },
    "160": {
        "startTime": 883.9,
        "endTime": 888.0,
        "transcript": "Tuaten tua-i iptaqameng qemimun cataitaqluteng.",
        "translation": "When they go out of view like that behind hills, they vanished."
    },
    "161": {
        "startTime": 889.0,
        "endTime": 891.0,
        "transcript": "Tuaten piluki nangvallurniit.",
        "translation": "They say that's mostly what depleted them."
    },
    "162": {
        "startTime": 893.0,
        "endTime": 894.5,
        "transcript": "Urqapiarallruut.",
        "translation": "They were extremely dirty."
    },
    "163": {
        "startTime": 895.0,
        "endTime": 899.0,
        "transcript": "Governemnt-aarurtellermeng kinguani urqapiarnillruit.",
        "translation": "After they were taken under the government, they say that were extremely dirty."
    },
    "164": {
        "startTime": 900.0,
        "endTime": 902.0,
        "transcript": "Tua-i-llu nangluteng.",
        "translation": "And then they were depleted."
    },
    "165": {
        "startTime": 902.5,
        "endTime": 908.0,
        "transcript": "Piqerluteng nangluteng wii pagaaviqtaaryaurrlua, ayagayaurrlua.",
        "translation": "One day when they were depleted, I started traveling up there."
    },
    "166": {
        "startTime": 910.5,
        "endTime": 917.0,
        "transcript": "Cali 15 years-aqatarlua wangnek drop out-arlua elitnaumek.",
        "translation": "Also, I dropped out of school by my own choice when I was going to turn 15 years [old]."
    },
    "167": {
        "startTime": 918.5,
        "endTime": 924.5,
        "transcript": "Yuilqumi akingengnaquralria una ataka ikayuangluku.",
        "translation": "I started helping my father make money from the wilderness."
    },
    "168": {
        "startTime": 925.5,
        "endTime": 930.5,
        "transcript": "Caliartaitellruami nuna, nunat wani melqulegteggun tau͡gaam.",
        "translation": "There were no jobs in the villages, only by [trading] fur."
    },
    "169": {
        "startTime": 931.5,
        "endTime": 936.5,
        "transcript": "Akitaunateng-llu elliiganek nunat, apqiitnek grant-anek.",
        "translation": "Villages didn't have donated money, what they call grants."
    },
    "170": {
        "startTime": 936.6,
        "endTime": 941.5,
        "transcript": "Melqulegpallurteggun tau͡gaam yuut unangengnaqaqluteng.",
        "translation": "People only got [money] mostly through [trading] fur."
    },
    "171": {
        "startTime": 942.0,
        "endTime": 946.0,
        "transcript": "Muriurluteng tuaten, equgkiurluteng kiagtuumaan.",
        "translation": "They also worked on lumber in the summer."
    },
    "172": {
        "startTime": 948.0,
        "endTime": 951.0,
        "transcript": "Akikangengnaqu'urluteng calirpagluteng.",
        "translation": "They worked hard to get money."
    },
    "173": {
        "startTime": 951.1,
        "endTime": 955.0,
        "transcript": "Quukataarluki tuaten napat iluatnek atrauquriaqluteng.",
        "translation": "They would even carry loads of wood down from the trees."
    },
    "174": {
        "startTime": 958.0,
        "endTime": 963.0,
        "transcript": "Tau͡gaam daddy-qa una ayagauralallruuq.",
        "translation": "But my daddy traveled a lot."
    },
    "175": {
        "startTime": 963.1,
        "endTime": 971.0,
        "transcript": "Tua-i neqem kinguani August-aami egmianun ayalallruukuk pagaavet ingrinun qanganarcuryarturlunuk",
        "translation": "We2 would go right after fishing in August up to the mountains to hunt for squirrels"
    },
    "176": {
        "startTime": 973.0,
        "endTime": 976.0,
        "transcript": "Akitulaata qanganaat amiit.",
        "translation": "Because squirrel skins were expensive."
    },
    "177": {
        "startTime": 979.5,
        "endTime": 985.0,
        "transcript": "Tamaani piqarraalallemni $15 akingqelallruuq one coat.",
        "translation": "Back when I first started, one coat cost $15."
    },
    "178": {
        "startTime": 985.5,
        "endTime": 991.5,
        "transcript": "Tau͡gaam nangliq'laamegnuk qanganarcuryarturaqlunuk.",
        "translation": "But because we would be short [on money], we would go hunt squirrels."
    },
    "179": {
        "startTime": 994.0,
        "endTime": 995.0,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "180": {
        "startTime": 996.0,
        "endTime": 1003.0,
        "transcript": "Tua-ll' elpeni-qaa mat'um nalliini makut ayagyuat",
        "translation": "And so to you, the young people these days"
    },
    "181": {
        "startTime": 1004.0,
        "endTime": 1010.0,
        "transcript": "Maaniunrilengraan, allani-llu nunani akusrarteńgut.",
        "translation": "Even outside of here, they're starting to be mischievous even in other villages."
    },
    "182": {
        "startTime": 1011.0,
        "endTime": 1019.0,
        "transcript": "Yaa, maa-i mat'um nalliini makut ayagyuaput kingum yui akusrartengut.",
        "translation": "Yes, the young people, our descendants,these days are becoming mischievous."
    },
    "183": {
        "startTime": 1020.0,
        "endTime": 1026.0,
        "transcript": "Cali unugmi caarkaituryugluteng, tua-i-w' tarrangyugluteng.",
        "translation": "And they have nothing to do at night, and tend to wander about."
    },
    "184": {
        "startTime": 1026.5,
        "endTime": 1028.0,
        "transcript": "Wangkucicetun pivkenateng.",
        "translation": "They're not like us."
    },
    "185": {
        "startTime": 1029.0,
        "endTime": 1030.0,
        "transcript": "Wangkuta tua-i nallumteńi,",
        "translation": "In our time,"
    },
    "186": {
        "startTime": 1030.5,
        "endTime": 1042.0,
        "transcript": "Uum-llu wani ciumni qallatellrem yua aiparnikellruamnuk tua-i nine clock, ten clock-ll' utercaraqellruarpuk aquirraarlunuk.",
        "translation": "And when the child of this one who spoke before me enjoyed each others' company, we went home early at nine [o']clock and ten [o']clock after playing."
    },
    "187": {
        "startTime": 1042.5,
        "endTime": 1047.0,
        "transcript": "Mat'um tang nalliini unugmi-llu, unuum-llu qukallran kinguani",
        "translation": "These days you see, at night, and after midnight"
    },
    "188": {
        "startTime": 1048.0,
        "endTime": 1055.5,
        "transcript": "Tarritessuutengnitekluteng snuukuuraluteng, fourwheel-araluteng tuaten piyaurtengelriit mat'um nalliini.",
        "translation": "Because they have vehicles, they've started going around with snow machines and even fourwheelers these days."
    },
    "189": {
        "startTime": 1056.5,
        "endTime": 1065.0,
        "transcript": "Cali makut ayagyuat, makut tua-i Yupiayagaat",
        "translation": "Also, these young people, these little Yupiit"
    },
    "190": {
        "startTime": 1065.5,
        "endTime": 1072.5,
        "transcript": "Aanaita picurlagluki wangkucicetun qalarutevkenaki anglicarluki.",
        "translation": "Their mothers make the mistake of raising them without speaking [in our language] as we were."
    },
    "191": {
        "startTime": 1073.5,
        "endTime": 1080.5,
        "transcript": "Elitetuut, mikelnguut elitetuut elitnaumi qitevquryaramek.",
        "translation": "They learn, these children learn to speak English in school."
    },
    "192": {
        "startTime": 1082.5,
        "endTime": 1086.5,
        "transcript": "Cat ilaitni maani avani-llu elitnaurviim elatiini",
        "translation": "Some days, here and over there outside of the school"
    },
    "193": {
        "startTime": 1088.5,
        "endTime": 1094.5,
        "transcript": "Yupiayaarnek makunek inerquilaryaaqua waten Yugtun qallallua.",
        "translation": "I admonish these little Yupiit speaking in Yup'ik like this."
    },
    "194": {
        "startTime": 1096.5,
        "endTime": 1102.5,
        "transcript": "Imkuyagaat tanegpayagaat kiugartelaqiitnga, “I don't know what you're talking about.”",
        "translation": "Those big boys would answer me, “I don't know what you're talking about.”"
    },
    "195": {
        "startTime": 1104.0,
        "endTime": 1109.5,
        "transcript": "Piciunrituq man'a qallacaraput cagmarluku, cagmangluku.",
        "translation": "It's not right that we should lose, start to lose our language."
    },
    "196": {
        "startTime": 1110.0,
        "endTime": 1115.0,
        "transcript": "Tuamta-llu iliini kiunauraatnga qalarutaqamki",
        "translation": "And then sometimes, they would answer when I speak to them"
    },
    "197": {
        "startTime": 1117.0,
        "endTime": 1123.0,
        "transcript": "Tamana-gguq kalikameggni ellimanrituq ukuni high school book-ani.",
        "translation": "That that is not written in their high school books."
    },
    "198": {
        "startTime": 1126.0,
        "endTime": 1128.9,
        "transcript": "Ukunun Kass'amteńun ingluangluteng.",
        "translation": "They've started converting to the Westerne ways in our region."
    },
    "199": {
        "startTime": 1129.5,
        "endTime": 1135.0,
        "transcript": "Tamatum-wa tua-i qitevquraulluki pilallrata pillikait.",
        "translation": "It's probably because they always speak English to them."
    },
    "200": {
        "startTime": 1137.0,
        "endTime": 1145.0,
        "transcript": "Cali man'a cagmangluku ayagayarateng.",
        "translation": "They've also started losing their traveling ways."
    },
    "201": {
        "startTime": 1147.0,
        "endTime": 1150.0,
        "transcript": "Yaavarraq-llu piyualuteng ayagciiganateng",
        "translation": "They can't walk a little ways over there either"
    },
    "202": {
        "startTime": 1150.5,
        "endTime": 1152.5,
        "transcript": "Taungitniluteng qanraqluteng.",
        "translation": "Saying that they don't have that [vehicle]."
    },
    "203": {
        "startTime": 1153.5,
        "endTime": 1158.5,
        "transcript": "Wangkuta avani tan'gurralleraullemteńi waten nun'aqertaqan",
        "translation": "Back when we were boys, when the land [became walkable] like this"
    },
    "204": {
        "startTime": 1159.0,
        "endTime": 1167.0,
        "transcript": "Qimugtengqengramta peggluki tua-i atunrirluki atmagturluta ayagalallruukut.",
        "translation": "Even though we had dogs, we left them behind and traveled with packs on our backs."
    },
    "205": {
        "startTime": 1168.0,
        "endTime": 1173.5,
        "transcript": "Ayarurrangqerturluta tau͡gaam alerquucimcetun.",
        "translation": "But we always had walking staffs as we were instructed."
    },
    "206": {
        "startTime": 1173.6,
        "endTime": 1176.9,
        "transcript": "Ayarurraicuunata tua-i nunaungraan-llu maani.",
        "translation": "We always had walking staffs even here in the village."
    },
    "207": {
        "startTime": 1177.0,
        "endTime": 1182.0,
        "transcript": "Nunaungraan nunakun ayangramta ayarurraq tegumiaqurluku",
        "translation": "Even when we walked through the village, we held a walking staff"
    },
    "208": {
        "startTime": 1185.0,
        "endTime": 1187.0,
        "transcript": "Tua-i alerquutekngamteggu.",
        "translation": "Because we were instructed to."
    },
    "209": {
        "startTime": 1190.0,
        "endTime": 1199.5,
        "transcript": "Yuut Yupiat alerquutaitni, amllepiartut tayima Yupiat alerquutait, qanruyutait-llu tayima.",
        "translation": "In Yup'ik instructions, Yupiit have a lot of instructions and traditional wisdom."
    },
    "210": {
        "startTime": 1201.0,
        "endTime": 1209.9,
        "transcript": "Elpeni iliit taukut alerquutet iliit cauga tukninqurrat",
        "translation": "For you, what is the most powerful of those instructions"
    },
    "211": {
        "startTime": 1210.0,
        "endTime": 1219.0,
        "transcript": "Wall'u-qaa angenqunqerrat qanruyutet yullret qanruyutek'lallrat?",
        "translation": "Or the most important traditional wisdom of the people back then?"
    },
    "212": {
        "startTime": 1221.5,
        "endTime": 1228.5,
        "transcript": "Angenqurrat ava-i qanrutkaqa: yuum pianek tegucaqunak. Teglegyaqunak.",
        "translation": "I just talked about the most important one: do not take other's things. Do not steal."
    },
    "213": {
        "startTime": 1228.6,
        "endTime": 1233.0,
        "transcript": "Angenqurrat tua-i tamamta qivrutuamta.",
        "translation": "That's the most important because we all get disappointed from loss."
    },
    "214": {
        "startTime": 1234.0,
        "endTime": 1235.0,
        "transcript": "Tua-i ava-i angenqurrat.",
        "translation": "That's the most important."
    },
    "215": {
        "startTime": 1235.5,
        "endTime": 1242.0,
        "transcript": "Tunglia-wa, ayagakumta ayaruq uitatesqevkenaku nunaungraan.",
        "translation": "Next, if we go anywhere, even inside the village, do not leave the walking staff."
    },
    "216": {
        "startTime": 1246.0,
        "endTime": 1250.0,
        "transcript": "Cikumi-llu piarkaukumta cingileggalegmek pisqelluta.",
        "translation": "And if we should go on ice, we should [test it] with a pointed tool."
    },
    "217": {
        "startTime": 1251.0,
        "endTime": 1257.0,
        "transcript": "Nunaungraan muraggaq ayaruliluku tak'urluku tegumiaquraasqelluku.",
        "translation": "Even in the village, make a long walking staff out of wood and hold it."
    },
    "218": {
        "startTime": 1259.0,
        "endTime": 1262.5,
        "transcript": "Tua-i nunaungraan, ingrini-llu mayualangramta",
        "translation": "Even in the village, and even when we went up mountains"
    },
    "219": {
        "startTime": 1262.6,
        "endTime": 1267.0,
        "transcript": "Ayarurraq tegumiaqerrlainarluku tarritetullruluta.",
        "translation": "We always walked around holding a walking staff."
    },
    "220": {
        "startTime": 1267.5,
        "endTime": 1269.0,
        "transcript": "Tua-i tunglia.",
        "translation": "That's the next [piece of wisdom]."
    },
    "221": {
        "startTime": 1269.5,
        "endTime": 1273.9,
        "transcript": "Iliini-llu anirtuqautekaqluku.",
        "translation": "And sometimes, it would save us."
    },
    "222": {
        "startTime": 1274.0,
        "endTime": 1277.9,
        "transcript": "Iquyaaqellemteńek aksallagvikluku ayaruq.",
        "translation": "When we're going to fall, we upheld ourselves with a staff."
    },
    "223": {
        "startTime": 1278.0,
        "endTime": 1283.0,
        "transcript": "Iliini-llu kuignayugteggun qeralriani",
        "translation": "And sometimes, when we cross streams"
    },
    "224": {
        "startTime": 1283.5,
        "endTime": 1289.5,
        "transcript": "Etuuralria nallunritetaqluku tamatum ayarum tuaggun qeraqaunrilucia.",
        "translation": "That staff lets us know which parts are deep and should not be crossed."
    },
    "225": {
        "startTime": 1289.6,
        "endTime": 1292.0,
        "transcript": "Allakun tau͡gaam yuaqerluta.",
        "translation": "We look for another path instead."
    },
    "226": {
        "startTime": 1292.9,
        "endTime": 1298.0,
        "transcript": "Alingnaqngami cali kuignayuunge'rmi pau͡gna ingrit.",
        "translation": "Even streams are dangerous up in the mountains."
    },
    "227": {
        "startTime": 1298.9,
        "endTime": 1308.0,
        "transcript": "Tua-i qanikcaq apqiitnek au͡gkut ciuliamta pissurpek'naarpek'nata pekeskumta neruiniciiqniluta.",
        "translation": "The snow, as our ancestors back then used to say, if we travel without [?probing], we will fall into hollows in the snow."
    },
    "228": {
        "startTime": 1308.1,
        "endTime": 1313.0,
        "transcript": "Iliini tua-i assirnganani una ayarumek kapellriani camna quutaitelartuq.",
        "translation": "Sometimes when we poke what looks good here, the [hollow] beneath does not close in."
    },
    "229": {
        "startTime": 1313.5,
        "endTime": 1317.0,
        "transcript": "Tamakunun ek'arrnayukluta ayaruitesqessuunata",
        "translation": "They told us to always have staffs because we might fall into those"
    },
    "230": {
        "startTime": 1317.5,
        "endTime": 1320.0,
        "transcript": "Apeqmeggnek neruinilluta.",
        "translation": "What they call neruinilluta."
    },
    "231": {
        "startTime": 1320.0,
        "endTime": 1325.0,
        "transcript": "Camna acia man'a qanikcarrlainaunge'rmi camna acia cagurpagluni.",
        "translation": "The area beneath, though this is all snow, the area beneath [?has a large hollow]."
    },
    "232": {
        "startTime": 1327.0,
        "endTime": 1332.9,
        "transcript": "Tamakunun ek'arrnayukluta nunaungraan tua-i ayarurraq tegumiaquraasqelaraat.",
        "translation": "Because we might fall into those, they told us to always have a staff even in the village."
    },
    "233": {
        "startTime": 1333.5,
        "endTime": 1338.0,
        "transcript": "Qeraqata'arqamta-llu una nequkilengraan tua-i yuvrirrlainarluku.",
        "translation": "And when we're going to cross, always examine it even if it's narrow."
    },
    "234": {
        "startTime": 1341.0,
        "endTime": 1343.0,
        "transcript": "Cali-qaa…",
        "translation": "Was there also…"
    }
};